import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ChatBubblePhone } from './Icons';
interface HeroProps {
  lang: 'en' | 'es';
  setLang: (lang: 'en' | 'es') => void;
}
export function Hero({
  lang,
  setLang
}: HeroProps) {
  const content = {
    en: {
      headline: 'Your Car. Any Brand. Best Deal.',
      subhead: "Miami's go-to sales pro. New & pre-owned vehicles across all makes and models — I find it, you drive it.",
      primaryCta: 'Get Started Now',
      secondaryCta: 'Get a Free Quote'
    },
    es: {
      headline: 'Tu Auto. Cualquier Marca. El Mejor Precio.',
      subhead: 'El asesor de confianza en Miami. Vehículos nuevos y usados de todas las marcas — yo lo encuentro, tú lo manejas.',
      primaryCta: 'Comienza Ahora',
      secondaryCta: 'Cotización Gratis'
    }
  };
  const t = content[lang];
  const scrollToForm = () => {
    document.getElementById('quote-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex h-screen min-h-[600px] w-full items-center justify-center overflow-hidden" data-id="element-22">
      <div className="absolute inset-0 z-0" data-id="element-23">
        <img src="https://cdn.magicpatterns.com/uploads/tjmmwwkCq3F7eDz7aoydR3/Confident_man_in_upscale_showroom.png" alt="Simon Alvarado" className="h-full w-full object-cover object-[center_20%]" data-id="element-24" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/85" data-id="element-25" />
      </div>

      <div className="absolute right-6 top-6 z-20 flex gap-2" data-id="element-26">
        <button type="button" onClick={() => setLang('en')} className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${lang === 'en' ? 'border-white bg-white text-black' : 'border-white/30 bg-transparent text-white/70 hover:border-white/60'}`} data-id="element-27">
          EN
        </button>
        <button type="button" onClick={() => setLang('es')} className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${lang === 'es' ? 'border-white bg-white text-black' : 'border-white/30 bg-transparent text-white/70 hover:border-white/60'}`} data-id="element-28">
          ES
        </button>
      </div>

      <div className="relative z-10 mx-auto mt-20 w-full max-w-5xl px-6 text-center" data-id="element-29">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="mb-6 text-5xl font-bold leading-tight tracking-tight text-white md:text-6xl lg:text-[56px]" data-id="element-30">
          {t.headline}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mb-10 max-w-2xl text-lg leading-relaxed text-[#aaaaaa] md:text-xl" data-id="element-31">
          {t.subhead}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-32">
          <button type="button" onClick={scrollToForm} className="flex w-full items-center justify-center gap-2 rounded-full bg-primary px-8 py-4 font-medium text-white transition-all hover:bg-blue-600 active:scale-[0.98] sm:w-auto" data-id="element-33">
            <ChatBubblePhone size={20} data-id="element-34" />
            {t.primaryCta}
          </button>

          <button type="button" onClick={scrollToForm} className="flex w-full items-center justify-center gap-2 rounded-full border border-white/30 bg-transparent px-8 py-4 font-medium text-white transition-all hover:border-white sm:w-auto" data-id="element-35">
            {t.secondaryCta}
            <ArrowDown size={20} data-id="element-36" />
          </button>
        </motion.div>
      </div>
    </section>;
}